import { Component, OnInit } from '@angular/core';
import { SpinnerService } from 'src/app/services/spinner.service';
import '@aileron/loading';

@Component({
    selector: 'spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    standalone: false
})
export class SpinnerComponent implements OnInit {

  public showSpinner : boolean = false;

  constructor(private spinnerService : SpinnerService) {
  }

  subscribeSpinner() {
    this.spinnerService.spinner$.subscribe((data: boolean) => {
        this.showSpinner = data ? data : false;
        this.toggleSpinner();
    });
  } 

  ngOnInit(): void {
    this.subscribeSpinner();
  }

  toggleSpinner() {
    let bodyElement = document.body;
    let spinnerEle = document.getElementsByTagName('spinner')[0] as HTMLElement;
    if(this.showSpinner) {
      bodyElement.classList.add('spinner-body');
      spinnerEle?.classList.add('spinner');
      document.documentElement.scrollTop = 0;
      bodyElement.scrollTop = 0;
    } else {
      bodyElement.classList.remove('spinner-body');
      spinnerEle?.classList.remove('spinner');
    }

  }
}